import React from 'react';
import { motion } from 'framer-motion';
import { SectionEyebrow } from './SectionEyebrow';
import { CoverImage } from './CoverImage';
import { CTAButton } from './CTAButton';
export function NoEsSoloEbook() {
  return <section className="py-24 md:py-32 px-6 bg-background relative overflow-hidden" data-id="element-141">
      <div className="container max-w-[1100px] mx-auto" data-id="element-142">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center" data-id="element-143">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="lg:col-span-7 lg:pr-10" data-id="element-144">
            <SectionEyebrow text="El propósito" className="mb-8" data-id="element-145" />

            <h2 className="text-4xl md:text-5xl lg:text-6xl text-foreground mb-10 leading-[1.1]" data-id="element-146">
              Este no es solo un ebook. Es el inicio de tu{' '}
              <span className="italic text-muted-foreground" data-id="element-147">
                reconstrucción.
              </span>
            </h2>

            <div className="space-y-8 text-lg md:text-xl text-muted-foreground font-light leading-[1.8]" data-id="element-148">
              <p data-id="element-149">
                Una transformación diseñada para la mujer que ya no quiere
                seguir mirando la vida de otras mientras posterga la suya, y
                está lista para sostener su valor con dignidad.
              </p>
              <p data-id="element-150">
                Dentro de esta experiencia, encontrarás el puente entre la mujer
                que eres hoy y la mujer que Dios diseñó que fueras: segura,
                capaz y profundamente conectada con su esencia.
              </p>
              <p className="font-serif text-2xl italic text-foreground mt-8" data-id="element-151">
                Aquí no se trata de ser otra. Se trata de volver a ser tú — sin
                las máscaras, sin las heridas, sin lo que te dijeron que tenías
                que ser.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.3
        }} className="lg:col-span-5 flex justify-center lg:justify-end" data-id="element-152">
            <div className="w-full max-w-[360px]" data-id="element-153">
              <CoverImage src="https://cdn.magicpatterns.com/uploads/5MGNjuQNrJY9EmSncq3zok/ChatGPT_Image_6_may_2026,_01_19_02_a.m._(2).png" alt="Declaraciones para volver a ti" rotation={2} data-id="element-154" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}